import { render } from "./LanguageSelect.vue?vue&type=template&id=56682362&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"

import "./LanguageSelect.vue?vue&type=style&index=0&id=56682362&scoped=true&lang=css"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-video-partners-2/v2-remove_noCodeAPI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56682362"]])

export default __exports__